// extracted by mini-css-extract-plugin
export default {"bodyContainer":"ArtTherapy_bodyContainer__uuf7D","formSection":"ArtTherapy_formSection__bN66D","socialSection":"ArtTherapy_socialSection__DZseT"};